import { render, staticRenderFns } from "./StepSubmit.vue?vue&type=template&id=a7b61e3a"
import script from "./StepSubmit.vue?vue&type=script&lang=ts"
export * from "./StepSubmit.vue?vue&type=script&lang=ts"
import style0 from "./StepSubmit.vue?vue&type=style&index=0&id=a7b61e3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports